import { render, staticRenderFns } from "./BCGovHeader.vue?vue&type=template&id=8defd64c&scoped=true"
import script from "./BCGovHeader.vue?vue&type=script&lang=js"
export * from "./BCGovHeader.vue?vue&type=script&lang=js"
import style0 from "./BCGovHeader.vue?vue&type=style&index=0&id=8defd64c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8defd64c",
  null
  
)

export default component.exports